export default async function ({ app, redirect }) {
  const authToken = await app.$cookies.get('authToken')
  if (!authToken) {
  } else {
    redirect('/')
  }
}
